// public/js/features/announcements/boot.js
// On app load: fetch announcements, show the modal for unread posts, and keep
// the account-dropdown "What's new" badge in sync.
import { loadAnnouncements } from './api.js';
import { openWhatsNewModal } from './whats-new-modal.js';

function unreadPosts(data) {
  const lastRead = Number(data.lastReadSeq || 0);
  return (data.posts || [])
    .filter(p => p.status === 'published' && (p.seq || 0) > lastRead)
    .sort((a, b) => b.seq - a.seq);
}

export function updateWhatsNewBadge(count) {
  const badge = document.getElementById('whats-new-badge');
  if (!badge) return;
  if (count > 0) { badge.textContent = count; badge.classList.remove('d-none'); }
  else badge.classList.add('d-none');
}

export async function checkWhatsNew() {
  let data;
  try { data = await loadAnnouncements(); } catch { return; }
  const unread = unreadPosts(data);
  updateWhatsNewBadge(unread.length);
  if (unread.length) {
    openWhatsNewModal(unread, () => updateWhatsNewBadge(0));  // cleared once read
  }
}

// Re-fetch just to refresh the badge (e.g. after visiting the archive).
export async function refreshWhatsNewBadge() {
  try { updateWhatsNewBadge(unreadPosts(await loadAnnouncements()).length); } catch { /* ignore */ }
}
